<template>
    <data-grid
        url="campaignPortalVisits"
        baseUrl="https://dinner-compaign.azurewebsites.net"
        :columns="columns"
        :title="title"
        :sortOptions="{
            enabled: true,
            field: 'timestamp',
            type: 'desc'
        }"
    ></data-grid>
</template>

<script>
export default {
    data: () => ({
        title: "Site Visits",
        columns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true
                }
            },
            {
                sortable: false,
                label: "Donor ID",
                field: "donorID",
                hidden: false,
                filterOptions: {
                    enabled: true
                }
            },
            {
                sortable: false,
                label: "Phone Number",
                field: "phone",
                hidden: false,
                filterOptions: {
                    enabled: true
                }
            },
            {
                sortable: true,
                label: "Timestamp",
                field: "timestamp",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true
                }
            }
        ]
    })
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
